import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const insuranceUnionListService = (
  params: Types.InsuranceUnionListRequest
) =>
  RestAPIClient.call<Types.InsuranceUnionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const insuranceUnionDetailService = (id: string) =>
  RestAPIClient.call<Types.InsuranceUnionDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const insuranceUnionCreateService = (
  params: Types.InsuranceUnionCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const insuranceUnionUpdateService = (
  params: Types.InsuranceUnionUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const insuranceUnionDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
